<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-13 12:19:47
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:59:20
 * @name: 更换经理
 * @Description: 更换经理
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\dialog\update-manager.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div>
    <addNeditDialog ref="addNeditDialog" title="更换经理" @close="close">
      <template v-slot:form>
        <div class="line">
          <font class="label"><i class="warn">*</i>请选择更换经理:</font>
          <el-select
            class="input"
            v-model="manager_id"
            placeholder="请选择更换经理"
          >
            <el-option
              v-for="item of pianoCompany.managers"
              :key="item.id"
              :label="item.realname"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
      </template>
      <template v-slot:btnGroup>
        <el-button class="submit" type="primary" @click="submit"
          >确认</el-button
        >
      </template>
    </addNeditDialog>
  </div>
</template>
<script>
import addNeditDialog from "@/components/pianoCompanyManage/dialog/addNeditDialog.vue";
import { debounceation } from "@/utils/decorator";

export default {
  name: "pianoCompanyManage-updateManager",
  components: {
    addNeditDialog,
  },
  props: {
    pianoCompany: {
      type: Object,
    },
  },
  data() {
    return {
      selectRow: [], //琴行表格选中项
      manager_id: "", //经理id
    };
  },
  computed: {
    // 验证销售经理是否已选
    manager_id_match() {
      return this.manager_id === "";
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 初始化data
     */
    initData() {
      this.selectRow = [];
      this.manager_id = "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Array} selectRow 琴行表格选中项
     */
    open(selectRow) {
      this.selectRow = selectRow;
      this.$refs.addNeditDialog.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗回调
     */
    close() {
      this.initData();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭弹窗
     */
    @debounceation(300)
    cancel() {
      this.$refs.addNeditDialog.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确认
     */
    @debounceation(300)
    submit() {
      if (this.manager_id_match) {
        this.$message.error("请选择更换经理!");
        return;
      }
      this.$emit("updateManager", {
        selectRow: this.selectRow,
        manager_id: this.manager_id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.line {
  margin-bottom: 20px;
  width: 100%;
  height: $Var-height-mormal;
  @extend .extend-flex-start;
  .label {
    font-size: $Vars-font-miniTitle-size;
    color: $Vars-font-normal-color;
    text-align: left;
    flex-shrink: 0;
    margin-right: 20px;
    position: relative;
    .warn {
      position: absolute;
      left: -10px;
      content: "*";
      color: red;
    }
  }
  .input {
    flex: 1;
  }
}
.submit {
  width: $Var-button-width-normal;
}
</style>